import React from "react";
import { Link } from "react-router-dom";
import intl from "react-intl-universal";

type FirstAccessShellProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  variant?: "default" | "verification";
};

export const FirstAccessShell: React.FC<FirstAccessShellProps> = ({
  title,
  subtitle,
  children,
  variant = "default",
}) => (
  <div
    className={
      variant === "verification"
        ? "login-glass-card login-glass-card--verification"
        : "login-glass-card"
    }
  >
    <div
      className={
        variant === "verification"
          ? "login-glass-card__header login-glass-card__header--center login-glass-card__header--verification"
          : "login-glass-card__header"
      }
    >
      <h1 className="login-glass-card__title">{title}</h1>
      {subtitle ? (
        <p
          className={
            variant === "verification"
              ? "login-glass-card__subtitle login-glass-card__subtitle--wide login-glass-card__subtitle--muted"
              : "login-glass-card__subtitle"
          }
        >
          {subtitle}
        </p>
      ) : null}
    </div>

    {variant === "verification" ? (
      <div className="login-verification-body">{children}</div>
    ) : (
      children
    )}

    <p className="login-glass-card__cta">
      {intl.get("firstAccess.alreadyHaveAccount")}{" "}
      <Link to="/auth" className="login-glass-card__cta-link">
        {intl.get("firstAccess.signIn")}
      </Link>
    </p>
  </div>
);
